import { Font, StyleSheet } from '@react-pdf/renderer';

import { proximaNovaFont } from '@/constants/font';

import theme from '../tokens';

Font.register(proximaNovaFont);

// Disable hyphenation so justified text distributes spacing without mid-word breaks
Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  page: {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.colors.background,
    width: '100%',
    height: '100%',
    paddingTop: theme.spacing.headerHeight,
    paddingBottom: theme.spacing.footerHeight + theme.spacing.footerOffset,
    paddingHorizontal: theme.spacing.pagePadding,
    display: 'flex',
    flexDirection: 'column',
  },

  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: theme.spacing.headerHeight,
    backgroundColor: theme.colors.background,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: theme.spacing.pagePadding,
    paddingTop: theme.spacing.headerPaddingTop,
  },

  logo: {
    width: 85,
    height: 22,
  },

  footer: {
    position: 'absolute',
    bottom: theme.spacing.footerOffset,
    left: 0,
    right: 0,
    height: theme.spacing.footerHeight,
    backgroundColor: theme.colors.background,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  footerText: {
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.muted,
    textAlign: 'center',
  },

  body: {
    flex: 1,
    flexDirection: 'column',
  },

  section: {
    marginBottom: theme.spacing.sectionGap,
  },

  sectionHeading: {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: 'bold',
    color: theme.colors.primary,
  },

  // Hero
  heroName: {
    fontSize: theme.typography.fontSize['4xl'],
    fontWeight: 'normal',
    color: theme.colors.foreground,
    marginTop: theme.spacing.displayMarginTop,
  },

  heroJobTitle: {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: 'bold',
    color: theme.colors.secondary,
  },

  heroLocation: {
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.secondary,
    marginBottom: theme.spacing.displayMarginBottom,
  },

  // Bullet list
  listRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingLeft: theme.spacing.listIndent,
  },

  listDot: {
    width: theme.spacing.bulletSize,
    height: theme.spacing.bulletSize,
    borderRadius: theme.spacing.bulletSize / 2,
    backgroundColor: theme.colors.foreground,
    marginTop: theme.spacing.bulletOffset,
    marginRight: theme.spacing.bulletGap,
  },

  bulletText: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
    textAlign: 'justify',
    flex: 1,
  },

  bulletLabel: {
    fontWeight: 'bold',
  },

  // Technical skills
  skillCategory: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
    fontWeight: 'bold',
  },

  skillText: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
    textAlign: 'justify',
    flex: 1,
  },

  // Experience / Education / Certifications
  jobTitle: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
    fontWeight: 'bold',
    marginTop: theme.spacing.entryTitleMarginTop,
  },

  entryMeta: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
  },
  entryBulletText: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight,
    color: theme.colors.foreground,
    textAlign: 'justify',
    flex: 1,
  },

  // Education and Certifications single-line entry (non-bold)
  entryLine: {
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.foreground,
    marginVertical: theme.spacing.bulletOffset,
  },

  entryGap: {
    marginBottom: theme.spacing.entryGap,
  },
});

export default styles;
